export const SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED';
export type SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED = typeof SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED;

export const SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER';
export type SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER = typeof SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER;

export const SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE';
export type SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE = typeof SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE;

export const SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL';
export type SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL = typeof SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL;

export const SET_PAYSIMPLE_PAYMENT_IS_PENDING =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_IS_PENDING';
export type SET_PAYSIMPLE_PAYMENT_IS_PENDING = typeof SET_PAYSIMPLE_PAYMENT_IS_PENDING;

export const SET_PAYSIMPLE_PAYMENT_ERROR =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_PAYMENT_ERROR';
export type SET_PAYSIMPLE_PAYMENT_ERROR = typeof SET_PAYSIMPLE_PAYMENT_ERROR;

export default {
  SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED,
  SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER,
  SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE,
  SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL,
  SET_PAYSIMPLE_PAYMENT_IS_PENDING,
  SET_PAYSIMPLE_PAYMENT_ERROR
};
